module.exports = [
  '#245cb3', // Dark blue
  '#b4ccfa', // lightning blue
  '#528beb', // sail blue
  '#05c0a0', // Smilo green
  '#003945', // Smilo Dark green
  '#a7a7a7', // Mr. grey
  '#0f728d', // website smilo color
  '#032b3f' // weird blue
];
